import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { signOut } from 'next-auth/react'
import { usePathname } from 'next/navigation'

export default function DiscordRoleReauthDialog({ open, setOpen }) {
  const pathname = usePathname()

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="min-h-[300px] w-4/5 p-5 sm:w-[400px] md:w-[650px]">
        <DialogHeader>
          <DialogTitle>Connect Discord to Community</DialogTitle>
          <DialogDescription>
            Re-authorise your Discord account and connect your Community to a
            Discord server!
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col justify-center gap-1 text-center text-p-2 font-medium">
          <p>
            You can now connect your Community to a Discord server! To do this,
            you first need to re-authorise your Discord account.
          </p>
          <p className="font-normal">Please sign out and back in.</p>
        </div>

        <DialogFooter className="md:items-end">
          <Button
            type="button"
            variant="outline"
            className="grow md:w-1/2"
            onClick={() => setOpen(false)}
          >
            Close
          </Button>
          <Button
            type="button"
            variant="success"
            className="grow md:w-1/2"
            autoFocus
            onClick={() => signOut({ callbackUrl: pathname })}
          >
            Sign Out
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
